import {useWindowDimensions} from 'react-native';
import {isMobile} from "react-device-detect";
import {size} from "./size";
import {light} from "./colors";
import {shadow} from "./shadow";

export const useTheme = () => {
    const {width} = useWindowDimensions();
    const contentWidth = isMobile ? width : size.previewCompactMaxWidth;

    const currentThemeName = 'light';
    const currentTheme = light;

    return {
        theme: currentThemeName,
        colors: {...currentTheme},
        size,
        shadow,
        contentWidth,
    };
};